
export const AppMenus = {
    
	navbarTopRightItems: [],
	navbarTopLeftItems: [],
	navbarSideLeftItems: [
  {
    "to": "/home",
    "label": "Indicadores",
    "icon": "pi pi-chart-line text-primary",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/data",
    "label": "FTP Log",
    "icon": "pi pi-database text-primary",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "",
    "label": "Administracion",
    "icon": "pi pi-cog text-primary",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/clients",
        "label": "Clientes",
        "icon": "pi pi-briefcase",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/devices",
        "label": "Dispositivos",
        "icon": "pi pi-stopwatch",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/users",
        "label": "Usuarios",
        "icon": "pi pi-users",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/permissions",
        "label": "Permissions",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/roles",
        "label": "Roles",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
        
      }
    ]
  }
],

    exportFormats: {
        print: {
			label: 'Print',
            icon: 'pi pi-print',
            type: 'print',
            ext: '',
        },
        pdf: {
			label: 'Pdf',
			
            icon: 'pi pi-file-pdf',
            type: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
            icon: 'pi pi-file-excel',
            type: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
            icon: 'pi pi-table',
            type: 'csv',
            ext: 'csv',
        },
    },
    
}